import { ReactUtils } from '@festina-life/core'
import { Tooltip } from '@festina-life/ui/feedback'
import { Typography } from '@festina-life/ui/structure'
import type { PropsWithChildren } from 'react'

export const OverviewTitle = ({
  children,
  tip,
  ...rest // needed for data-test-id and similar props
}: PropsWithChildren<{ tip?: string }>) => (
  <ReactUtils.ConditionalWrap
    condition={!!tip}
    wrap={(children) => (
      <Tooltip tip={tip} placement="right">
        {children}
      </Tooltip>
    )}
  >
    <Typography weight="semibold" as="h2" {...rest}>
      {children}
    </Typography>
  </ReactUtils.ConditionalWrap>
)
